import { getLocations } from '@/services/webApi';
import { useQuery } from '@tanstack/react-query';

export default function useLocationsQuery(enabled = true) {
  return useQuery({
    queryKey: ['locations'],
    retry: false,
    enabled,
    queryFn: () => getLocations(),
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5
  });
}
